import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout, isAuthenticated, getCurrentUser } from '../services/auth';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authenticated = isAuthenticated();
  const currentUser = getCurrentUser();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  // Don't show header on login page
  if (location.pathname === '/login') {
    return null;
  }
  
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <i className="bi bi-graph-up me-2"></i>
          Signal Monkey
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              active={location.pathname === '/'}
            >
              All Signals
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/active-trades" 
              active={location.pathname === '/active-trades'}
            >
              Active Trades
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/risk-management"
              active={location.pathname === '/risk-management'}
            >
              <i className="bi bi-shield-check me-1"></i>
              Risk Management
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/setups"
              active={location.pathname === '/setups'}
            >
              💎 Setups
            </Nav.Link>
          </Nav>
          
          {authenticated && (
            <div className="d-flex align-items-center">
              <span className="text-light me-3">
                <small>Logged in as: </small>
                <strong>{currentUser?.username || 'User'}</strong>
              </span>
              <Button 
                variant="outline-light" 
                size="sm"
                onClick={handleLogout}
              >
                Logout
              </Button>
            </div>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;